export const ACCREDITATION_4_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_image: "",
    meta_alt_image: "Highlight",
    meta_heading: "Trusted Among the World's Best",
    meta_description:
      "Chandigarh University proudly ranks among the top institutions globally in the QS World University Rankings.",
    meta_priority: 1,
    meta_status: true,
  },

  ACCREDITATION_4_FIELDS_CONFIG: [
    {
      fieldName: "background_color",
      label: "Section background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title_primary_color",
      label: "Main title text color",
      value: "#171719",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#171719",
      required: false,
      defaultValue: "#171719",
    },
    {
      fieldName: "body_text_color",
      label: "Description text color",
      value: "#373737",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#373737",
      required: false,
      defaultValue: "#373737",
    },
    {
      fieldName: "card_active_bg_color",
      label: "Selected card background",
      value: "#FFEFEE",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFEFEE",
      required: false,
      defaultValue: "#FFEFEE",
    },
    {
      fieldName: "card_inactive_bg_color",
      label: "Unselected card background",
      value: "#F4F4F4",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#F4F4F4",
      required: false,
      defaultValue: "#F4F4F4",
    },
    {
      fieldName: "card_title_color",
      label: "Card title text color",
      value: "#171719",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#171719",
      required: false,
      defaultValue: "#171719",
    },
    {
      fieldName: "status",
      label: "Accreditation (selectable highlights) status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable section",
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Card icon",
      fieldName: "meta_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload icon",
    },
    {
      header: "Icon alt",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Alt text",
    },
    {
      header: "Title (card + main heading)",
      fieldName: "meta_heading",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Trusted Among the World's Best",
    },
    {
      header: "Description",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Description shown when selected",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Priority",
      required: true,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable item",
      defaultValue: true,
    },
  ],
};
